import { compR } from "../func/compr";
import { $iter } from "../iterator";
export function mapIndexed() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return $iter(mapIndexed, args) || function (rfn) {
    var r = rfn[2];
    var fn = args[0];
    var i = args[1] || 0;
    return compR(rfn, function (acc, x) {
      return r(acc, fn(i++, x));
    });
  };
}